"use strict";
function svg2html() {
    var elements = document.querySelectorAll("img.svg");
    elements.forEach(function (element) {
        var img = element;
        var imgID = img.getAttribute("id") || "";
        var imgClass = img.getAttribute("class") || "";
        var imgURL = img.getAttribute("src") || "";
        var xhr = new XMLHttpRequest();
        xhr.open("GET", imgURL, true);
        xhr.onreadystatechange = function () {
            var _a;
            if (xhr.readyState === 4 && xhr.status === 200) {
                var data = xhr.response;
                var parser = new DOMParser();
                var svgDoc = parser.parseFromString(data, "image/svg+xml");
                var svg = svgDoc.querySelector("svg");
                if (svg) {
                    if (typeof imgID !== "undefined") {
                        svg.setAttribute("id", imgID);
                    }
                    if (typeof imgClass !== "undefined") {
                        svg.setAttribute("class", imgClass + " replaced-svg");
                    }
                    svg.removeAttribute("xmlns:a");
                    if (img) {
                        (_a = img.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(svg, img);
                    }
                }
            }
        };
        xhr.send();
    });
}
var confettiShown = false;
var ccdConfettiShownDate = localStorage.getItem('ccdConfettiShownDate');
if (ccdConfettiShownDate) {
    var confettiDate = new Date(ccdConfettiShownDate);
    var currentDate = new Date();
    var diffTime = Math.abs(currentDate.getTime() - confettiDate.getTime());
    if (diffTime < 3600000) {
        confettiShown = true;
    }
}
document.addEventListener('DOMContentLoaded', function () {
    svg2html();
}, false);
setupAddToCartListeners();
function setupAddToCartListeners() {
    // Add to cart code for single and grid sections
    var addToCartButtons = document.querySelectorAll('.add-to-cart');
    if (addToCartButtons && addToCartButtons.length) {
        addToCartButtons.forEach(function (addToCartButton) {
            addToCartButton.addEventListener('click', function (e) {
                var _a, _b, _c;
                e.preventDefault();
                (_a = addToCartButton.querySelector('.loading-spinner')) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
                (_b = addToCartButton.querySelectorAll('img:not(.loading-spinner):not(.tick)')) === null || _b === void 0 ? void 0 : _b.forEach(function (img) {
                    img.classList.add('d-none');
                });
                (_c = addToCartButton.querySelector('span')) === null || _c === void 0 ? void 0 : _c.classList.add('d-none');
                var quantity = 1;
                var productId = parseInt(addToCartButton.getAttribute("data-id") || "0");
                var quantityInput = null;
                // .product-item-add-to-cart is used to indicate it was an add to cart from the product-item component and not a SPP page
                if (!addToCartButton.classList.contains("product-item-add-to-cart")) {
                    if (window.innerWidth < 768) {
                        quantityInput = document.querySelector('.single-product .floated-focus-block .quantity-controller input');
                    }
                    else {
                        quantityInput = document.querySelector('.single-product .focus-block .quantity-controller input');
                    }
                }
                if (quantityInput) {
                    quantity = parseInt(quantityInput.value || "0");
                }
                cart.add_product(productId, quantity, {}, function () {
                    var _a, _b, _c, _d, _e;
                    addToCartButton.classList.add('green-bg');
                    (_a = addToCartButton.querySelector('.loading-spinner')) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
                    (_b = addToCartButton.querySelector('.tick')) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
                    (_c = addToCartButton.querySelectorAll('img:not(.loading-spinner):not(.plus)')) === null || _c === void 0 ? void 0 : _c.forEach(function (img) {
                        img.classList.remove('d-none');
                    });
                    (_d = addToCartButton.querySelector('span')) === null || _d === void 0 ? void 0 : _d.classList.remove('d-none');
                    var span = addToCartButton.querySelector('span');
                    if (span) {
                        span.classList.add('white-text');
                        span.textContent = "Added!";
                    }
                    (_e = document.querySelector('header .cart-counter')) === null || _e === void 0 ? void 0 : _e.classList.add('pulse');
                    setTimeout(function () {
                        var _a;
                        (_a = document.querySelector('header .cart-counter')) === null || _a === void 0 ? void 0 : _a.classList.remove('pulse');
                    }, 500);
                    setTimeout(function () {
                        var _a, _b;
                        addToCartButton.classList.remove('green-bg');
                        (_a = addToCartButton.querySelector('.tick')) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
                        (_b = addToCartButton.querySelector('.plus')) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
                        var span = addToCartButton.querySelector('span');
                        if (span) {
                            span.classList.remove('white-text');
                            span.textContent = "Add to Cart";
                        }
                    }, 2000);
                });
            });
        });
    }
}
var freeShippingUpsells = document.querySelectorAll(".checkout .cart-free-shipping-upsell");
freeShippingUpsells.forEach(function (upsellElement) {
    runFreeShippingUpsell(upsellElement, false);
});
var stickyCartUpsellElement = document.querySelector(".sticky-cart .cart-free-shipping-upsell");
if (stickyCartUpsellElement) {
    runFreeShippingUpsell(stickyCartUpsellElement, true);
}
function runFreeShippingUpsell(upsellElement, isSticky) {
    var _a, _b, _c, _d, _e, _f, _g;
    var cartTotal = parseInt((upsellElement === null || upsellElement === void 0 ? void 0 : upsellElement.getAttribute('data-amount')) || "0");
    if (cartTotal === 0) {
        upsellElement.classList.add("d-none");
    }
    else {
        upsellElement.classList.remove("d-none");
        // First hide or show elements before animating
        if (cartTotal < 80000) {
            (_a = upsellElement.querySelector(".amount-text")) === null || _a === void 0 ? void 0 : _a.classList.remove("d-none");
            (_b = upsellElement.querySelector(".free-delivery")) === null || _b === void 0 ? void 0 : _b.classList.remove("d-none");
            (_c = upsellElement.querySelector(".free-delivery-success")) === null || _c === void 0 ? void 0 : _c.classList.add("d-none");
        }
        else {
            (_d = upsellElement.querySelector(".amount-text")) === null || _d === void 0 ? void 0 : _d.classList.add("d-none");
            (_e = upsellElement.querySelector(".free-delivery")) === null || _e === void 0 ? void 0 : _e.classList.add("d-none");
            (_f = upsellElement.querySelector(".free-delivery-success")) === null || _f === void 0 ? void 0 : _f.classList.remove("d-none");
        }
        var amountToStillSpend = ((80000 - cartTotal) / 100).toFixed(2);
        upsellElement.querySelector(".amount-value").textContent = "R" + amountToStillSpend;
        var percentageComplete = ((cartTotal / 80000) * 100);
        if (percentageComplete > 70 && percentageComplete < 100) {
            percentageComplete = 70;
        }
        if (percentageComplete >= 100) {
            upsellElement.setAttribute('data-got-free-shipping', 'true');
            animateCartToPercentage(upsellElement, 95);
            var currentFreeShippingElementStatus_1 = (upsellElement === null || upsellElement === void 0 ? void 0 : upsellElement.getAttribute('data-got-free-shipping')) || "false";
            setTimeout(function () {
                var _a, _b;
                if (currentFreeShippingElementStatus_1 === "false") {
                    upsellElement.querySelector(".box").style.opacity = "1";
                    upsellElement.querySelector(".progress-bar").style.opacity = "1";
                    upsellElement.querySelector(".progress-bar-bg").style.opacity = "1";
                    (_a = upsellElement.querySelector(".truck")) === null || _a === void 0 ? void 0 : _a.classList.remove("center");
                }
                else {
                    upsellElement.querySelector(".box").style.opacity = "0";
                    upsellElement.querySelector(".progress-bar").style.opacity = "0";
                    upsellElement.querySelector(".progress-bar-bg").style.opacity = "0";
                    (_b = upsellElement.querySelector(".truck")) === null || _b === void 0 ? void 0 : _b.classList.add("center");
                }
            }, 750);
            setTimeout(function () {
                if (currentFreeShippingElementStatus_1 === "false") {
                    upsellElement.querySelector(".free-delivery-success").style.opacity = "0";
                }
                else {
                    upsellElement.querySelector(".free-delivery-success").style.opacity = "1";
                }
            }, 1500);
            setTimeout(function () {
                var _a;
                var targetElement = null;
                if (isSticky && ((_a = document.querySelector('.sticky-cart')) === null || _a === void 0 ? void 0 : _a.classList.contains('open'))) {
                    targetElement = document.querySelector('.sticky-cart .checkout-btn');
                }
                else {
                    targetElement = document.querySelector('.checkout-button.desktop');
                    if (window.innerWidth < 992) {
                        targetElement = document.querySelector('.checkout-button.mobile');
                    }
                }
                if (targetElement && confettiShown === false) {
                    confettiShown = true;
                    localStorage.setItem('ccdConfettiShownDate', new Date().toISOString());
                    var rect = targetElement.getBoundingClientRect();
                    // Get center coordinates of the element
                    var x = (rect.left + rect.width / 2) / window.innerWidth;
                    var y = (rect.top + rect.height / 2) / window.innerHeight;
                    // @ts-ignore
                    confetti({
                        particleCount: 100,
                        spread: 50,
                        origin: {
                            x: x,
                            y: y
                        }
                    });
                }
            }, 1700);
        }
        else {
            upsellElement.setAttribute('data-got-free-shipping', 'false');
            upsellElement.querySelector(".box").style.opacity = "1";
            upsellElement.querySelector(".progress-bar").style.opacity = "1";
            upsellElement.querySelector(".progress-bar-bg").style.opacity = "1";
            (_g = upsellElement.querySelector(".truck")) === null || _g === void 0 ? void 0 : _g.classList.remove("center");
            upsellElement.querySelector(".free-delivery-success").style.opacity = "0";
            animateCartToPercentage(upsellElement, percentageComplete);
        }
    }
}
function animateCartToPercentage(upsellElement, percentageComplete) {
    var percentageCompleteString = percentageComplete.toFixed(0);
    var progressBar = upsellElement.querySelector(".progress-bar");
    var progressIcon = upsellElement.querySelector(".box");
    if (progressBar && progressIcon) {
        progressBar.setAttribute('style', "width: ".concat(percentageCompleteString, "%"));
        var freeDeliveryWidget = upsellElement.querySelector(".free-delivery-widget");
        var elementWidth = (freeDeliveryWidget === null || freeDeliveryWidget === void 0 ? void 0 : freeDeliveryWidget.clientWidth) || 0;
        var widthPercentage = ((elementWidth * (parseInt(percentageCompleteString) / 100)) - 22).toFixed(0);
        progressIcon.setAttribute('style', "left: ".concat(widthPercentage, "px"));
    }
}
var newsletterForms = document.querySelectorAll("form.newsletter-form");
newsletterForms.forEach(function (form) {
    form.addEventListener("submit", function (e) {
        e.preventDefault();
        form.querySelector("button[type='submit']").textContent = "Loading...";
        var formElement = e.target;
        var formData = new FormData(formElement);
        var email = formData.get("email");
        var honeyPot = formData.get("name");
        if (honeyPot) {
            return;
        }
        var newsletterUrl = 'https://ccd-typescript-api-5341184e38bc.herokuapp.com/database/subscribe';
        fetch(newsletterUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email: email
            })
        }).then(function (response) {
            response.json().then(function (jsonResponse) {
                if (jsonResponse.result === true) {
                    var url = new URL(form.action, window.location.origin);
                    url.searchParams.set('email', email);
                    url.searchParams.set('redirect', 'true');
                    window.location.href = url.toString();
                }
            });
        });
    });
});
// Needed for bfcache
document.addEventListener("DOMContentLoaded", function () {
    cart.update_cart();
    initBackInStockForms();
    initBackInStockPopup();
});
var NOTIFY_URL = 'https://ccd-typescript-api-5341184e38bc.herokuapp.com/shopify/products/subscriptions/backinstock';
function handleSmsSubscribe(checkbox) {
    var _a;
    var form = checkbox.closest('form');
    (_a = form === null || form === void 0 ? void 0 : form.querySelector('.phone-number-wrapper')) === null || _a === void 0 ? void 0 : _a.classList.toggle('d-none');
}
// @ts-ignore
window.handleSmsSubscribe = handleSmsSubscribe;
function getBackInStockVariantId(contextEl) {
    var activeVariant = contextEl.querySelector('.variant.active');
    if (activeVariant) {
        return parseInt(activeVariant.getAttribute('id') || '0');
    }
    return parseInt(contextEl.getAttribute('data-primary-variant-id') || '0');
}
function resetBackInStockForm(form) {
    var _a;
    var defaultMessage = 'Sold out! Awaiting stock. Get notified.';
    var messageParagraph = form.querySelector('p');
    if (messageParagraph) {
        messageParagraph.className = 'd-flex align-items-center';
        messageParagraph.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0505/3071/3798/files/time.svg?v=1694178330" alt="Sold out icon"><span>' + defaultMessage + '</span>';
    }
    form.querySelectorAll('input:not([type="checkbox"])').forEach(function (input) {
        input.style.display = '';
        if (input instanceof HTMLInputElement) {
            input.value = '';
            input.disabled = false;
        }
    });
    form.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
        checkbox.checked = false;
        checkbox.style.display = '';
    });
    form.querySelectorAll('label').forEach(function (label) {
        label.style.display = '';
    });
    form.querySelectorAll('br').forEach(function (br) {
        br.style.display = '';
    });
    (_a = form.querySelector('.phone-number-wrapper')) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
    var submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) {
        submitButton.style.display = '';
        submitButton.textContent = 'Notify Me';
        submitButton.disabled = false;
    }
}
function setupBackInStockForm(form, contextEl) {
    form.onsubmit = function (event) {
        var _a, _b, _c, _d, _e;
        event.preventDefault();
        var target = event.target;
        var email = ((_a = target.elements.namedItem('email')) === null || _a === void 0 ? void 0 : _a.value) || '';
        var phone = ((_b = target.elements.namedItem('phone')) === null || _b === void 0 ? void 0 : _b.value) || '';
        var firstName = ((_c = target.elements.namedItem('name')) === null || _c === void 0 ? void 0 : _c.value) || '';
        var subscribeToMailingList = ((_d = target.elements.namedItem('subscribe')) === null || _d === void 0 ? void 0 : _d.checked) || false;
        var subscribeToSmsList = ((_e = target.elements.namedItem('smsSubscribe')) === null || _e === void 0 ? void 0 : _e.checked) || false;
        var productId = parseInt(contextEl.getAttribute('data-product-id') || '0');
        var variantId = getBackInStockVariantId(contextEl);
        var body = {
            productVariantId: variantId,
            productId: productId,
            emailAddress: email
        };
        if (firstName) {
            body.firstName = firstName;
        }
        if (subscribeToMailingList === true) {
            body.subscribeToMailingList = subscribeToMailingList;
        }
        if (subscribeToSmsList === true) {
            body.subscribeToSmsList = subscribeToSmsList;
            body.phone = phone;
        }
        var submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
            submitButton.textContent = 'Loading...';
            submitButton.disabled = true;
        }
        fetch(NOTIFY_URL, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        }).then(function (response) {
            response.json().then(function (data) {
                var successMessage = data.message || 'Success';
                var messageParagraph = form.querySelector('p');
                var emailInput = form.querySelector('input[type="email"]');
                var textInput = form.querySelector('input[type="text"]');
                var phoneInput = form.querySelector('input[type="tel"]');
                var checkboxInputs = form.querySelectorAll('input[type="checkbox"]');
                var labels = form.querySelectorAll('label');
                var brs = form.querySelectorAll('br');
                var button = form.querySelector('button[type="submit"]');
                if (messageParagraph && emailInput && textInput && phoneInput && checkboxInputs.length && labels.length && brs.length && button) {
                    messageParagraph.textContent = successMessage;
                    emailInput.style.display = 'none';
                    textInput.style.display = 'none';
                    phoneInput.style.display = 'none';
                    checkboxInputs.forEach(function (checkbox) {
                        checkbox.style.display = 'none';
                    });
                    labels.forEach(function (label) {
                        label.style.display = 'none';
                    });
                    brs.forEach(function (br) {
                        br.style.display = 'none';
                    });
                    button.style.display = 'none';
                }
            }).catch(function (error) {
                console.log(error);
                var messageParagraph = form.querySelector('p');
                if (messageParagraph) {
                    messageParagraph.textContent = 'An error has occured';
                }
            });
        });
    };
}
function initBackInStockForms() {
    document.querySelectorAll('.back-in-stock-form').forEach(function (form) {
        if (form.closest('.back-in-stock-popup')) {
            return;
        }
        var contextEl = form.closest('.single-product');
        if (contextEl) {
            setupBackInStockForm(form, contextEl);
        }
    });
}
function openBackInStockPopup(productId, variantId) {
    var backInStockPopup = document.querySelector('.back-in-stock-popup');
    var backInStockPopupBackground = backInStockPopup === null || backInStockPopup === void 0 ? void 0 : backInStockPopup.querySelector('.popup-background');
    var backInStockModalContext = backInStockPopup === null || backInStockPopup === void 0 ? void 0 : backInStockPopup.querySelector('.single-product');
    var backInStockModalForm = backInStockPopup === null || backInStockPopup === void 0 ? void 0 : backInStockPopup.querySelector('.back-in-stock-form');
    if (!backInStockPopup || !backInStockModalContext || !backInStockModalForm) {
        return;
    }
    backInStockModalContext.setAttribute('data-product-id', productId.toString());
    backInStockModalContext.setAttribute('data-primary-variant-id', variantId.toString());
    resetBackInStockForm(backInStockModalForm);
    backInStockPopup.classList.remove('d-none');
    backInStockPopupBackground === null || backInStockPopupBackground === void 0 ? void 0 : backInStockPopupBackground.classList.remove('d-none');
}
function closeBackInStockPopup() {
    var backInStockPopup = document.querySelector('.back-in-stock-popup');
    var backInStockPopupBackground = backInStockPopup === null || backInStockPopup === void 0 ? void 0 : backInStockPopup.querySelector('.popup-background');
    backInStockPopup === null || backInStockPopup === void 0 ? void 0 : backInStockPopup.classList.add('d-none');
    backInStockPopupBackground === null || backInStockPopupBackground === void 0 ? void 0 : backInStockPopupBackground.classList.add('d-none');
}
function initBackInStockPopup() {
    var _a;
    var backInStockPopup = document.querySelector('.back-in-stock-popup');
    var backInStockPopupBackground = backInStockPopup === null || backInStockPopup === void 0 ? void 0 : backInStockPopup.querySelector('.popup-background');
    var backInStockModalContext = backInStockPopup === null || backInStockPopup === void 0 ? void 0 : backInStockPopup.querySelector('.single-product');
    var backInStockModalForm = backInStockPopup === null || backInStockPopup === void 0 ? void 0 : backInStockPopup.querySelector('.back-in-stock-form');
    if (backInStockModalForm && backInStockModalContext) {
        setupBackInStockForm(backInStockModalForm, backInStockModalContext);
    }
    (_a = backInStockPopup === null || backInStockPopup === void 0 ? void 0 : backInStockPopup.querySelector('.close')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function (e) {
        e.preventDefault();
        closeBackInStockPopup();
    });
    backInStockPopupBackground === null || backInStockPopupBackground === void 0 ? void 0 : backInStockPopupBackground.addEventListener('click', function (e) {
        e.preventDefault();
        closeBackInStockPopup();
    });
    document.addEventListener('click', function (e) {
        var notifyBtn = e.target.closest('.notify-me');
        if (notifyBtn) {
            e.preventDefault();
            var productId = parseInt(notifyBtn.getAttribute('data-product-id') || '0');
            var variantId = parseInt(notifyBtn.getAttribute('data-variant-id') || '0');
            openBackInStockPopup(productId, variantId);
        }
    });
}
var subscribePopup = document.querySelector('.subscribe-popup:not(.back-in-stock-popup)');
var popupBackground = subscribePopup === null || subscribePopup === void 0 ? void 0 : subscribePopup.querySelector('.popup-background');
var subscribeLocalStorageKey = "subscribe-popup-dismissed";
var showPopup = localStorage.getItem(subscribeLocalStorageKey);
if (!showPopup) {
    var popupShown_1 = false;
    document.addEventListener('scroll', function () {
        if (popupShown_1) {
            return;
        }
        var scrollPosition = window.scrollY || document.documentElement.scrollTop;
        if (scrollPosition > 500 && subscribePopup && popupBackground) {
            popupShown_1 = true;
            localStorage.setItem(subscribeLocalStorageKey, new Date().toISOString());
            subscribePopup.classList.remove("d-none");
            popupBackground.classList.remove("d-none");
            setTimeout(function () {
                var _a;
                (_a = subscribePopup.querySelector(".close")) === null || _a === void 0 ? void 0 : _a.classList.add("rotate");
            }, 500);
        }
    });
    document.querySelectorAll('.subscribe-popup:not(.back-in-stock-popup) .close, .subscribe-popup:not(.back-in-stock-popup) .popup-background').forEach(function (closeButton) {
        closeButton.addEventListener('click', function (e) {
            e.preventDefault();
            if (subscribePopup && popupBackground) {
                subscribePopup.classList.add("d-none");
                popupBackground.classList.add("d-none");
                localStorage.setItem(subscribeLocalStorageKey, new Date().toISOString());
            }
        });
    });
}
